import { client } from "../client/client";

export const generateReport = async (
  page,
  limit,
  startDate,
  endDate,
  type,
  branchId,
  productIds,
  status
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (type) params.append("type", type);
    if (branchId) params.append("branchId", branchId);
    if (productIds) params.append("productIds", productIds);
    if (status) params.append("status", status);
    const response = await client.get(`/report/generate?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const downloadGeneratedReport = async (
  page,
  limit,
  startDate,
  endDate,
  type,
  branchId,
  productIds,
  status,
  exportFile
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (type) params.append("type", type);
    if (branchId) params.append("branchId", branchId);
    if (productIds) params.append("productIds", productIds);
    if (status) params.append("status", status);
    if (exportFile) params.append("export", exportFile);
    const response = await client.get(`/report/generate?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getBorrowerStatistics = async () => {
  try {
    const response = await client.get("/report/analytics/borrower-statistics");
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getBorrowerGrowthRate = async () => {
  try {
    const response = await client.get("/report/analytics/borrower-growth-rate");
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getDisbursementStatistics = async () => {
  try {
    const response = await client.get("/report/analytics/disbursement-statistics");
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanTenure = async () => {
  try {
    const response = await client.get("/report/analytics/loan-tenure");
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanProductSummary = async () => {
  try {
    const response = await client.get("/report/analytics/loan-product-counts");
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanDefaultRate= async () => {
  try {
    const response = await client.get("/report/analytics/loan-default-rate");
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
